import { Injectable } from '@angular/core';
import { AsyncSubject, Observable } from 'rxjs';

import { TarlV3Jsonapi } from '®shared/tarl-v3-jsonapi';
import { DcSettings } from '®shared/tenant/dc-settings';
import { WindowShimService } from '®shared/window-shim';

import { RequestDigitisationFinishedReason } from './request-digitisation.actions';

@Injectable()
export class RequestDigitisationService {
  constructor(
    private window: WindowShimService,
    private tarlV3Jsonapi: TarlV3Jsonapi,
  ) {}
  /**
   * Initialises a message event listener and listens for a
   * RequestDigitisationFinishedReason as an Observable.
   *
   * @return {Observable<RequestDigitisationFinishedReason>} - The message from DC which
   * will either be 'close' or 'cancel'.
   */
  getRequestDigitisationFinishedReason(): Observable<RequestDigitisationFinishedReason> {
    const messageSubject =
      new AsyncSubject<RequestDigitisationFinishedReason>();

    // We cannot use PostMessageBridgeFactory because that expects a channel
    // and DC does not use channels.
    this.window.addEventListener('message', (message: MessageEvent) => {
      if (
        message.data === RequestDigitisationFinishedReason.CANCELLED ||
        message.data === RequestDigitisationFinishedReason.COMPLETED
      ) {
        messageSubject.next(message.data);
        messageSubject.complete();
      }
    });

    return messageSubject.asObservable();
  }

  getDcSettings() {
    return this.tarlV3Jsonapi.getResource<DcSettings>('dc/settings');
  }
}
